import {
  EventIncidentsQueue,
  parseRawQueueIncidents,
} from '@collector/desktop-feature-incidents-queue-core'
import { Event } from '@collector/sportsapi-client-legacy'
import { sportsApiClient } from '@desktop/globalState/sportsApiClient'

import { captureQueueIncidentErrors } from './sentry'
import {
  getEventIncidentsQueueRecord,
  persistOnChangeEventIncidentsQueue,
} from './storage'

export async function initEventIncidentsQueue(
  eventId: Event['id'],
): Promise<EventIncidentsQueue> {
  const eventIncidentsQueue = new EventIncidentsQueue(eventId, sportsApiClient)
  const eventIncidentsQueueRecord = await getEventIncidentsQueueRecord(eventId)

  if (eventIncidentsQueueRecord) {
    eventIncidentsQueue.queue = parseRawQueueIncidents(
      eventIncidentsQueueRecord.rawQueueIncidents,
    )

    eventIncidentsQueue.queueStatus = eventIncidentsQueueRecord.queueStatus
  }

  persistOnChangeEventIncidentsQueue(eventIncidentsQueue)
  captureQueueIncidentErrors(eventIncidentsQueue)

  return eventIncidentsQueue
}
